var _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8ToDo50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#90CAF9",
    d: "M4 9H25V13H4zM4 22H25V26H4zM4 35H25V39H4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F44336",
    d: "M30.053 33.31L32.288 31.068 41.973 40.777 39.738 43.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F44336",
    d: "M32.288 43.02L30.053 40.777 39.738 31.068 41.973 33.31z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4CAF50",
    d: "M28.893 9.864H37.893V12.864H28.893z",
    transform: "rotate(45.001 33.393 11.363)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4CAF50",
    d: "M37.197 4.303H40.197V16.303H37.197z",
    transform: "rotate(-134.999 38.697 10.303)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4CAF50",
    d: "M28.893 21.864H37.893V24.864H28.893z",
    transform: "rotate(45.001 33.394 23.364)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4CAF50",
    d: "M37.197 16.303H40.197V28.303H37.197z",
    transform: "rotate(-134.999 38.697 22.303)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ToDo50);
export default __webpack_public_path__ + "static/media/icons8-to-do-50.ce9e29050b15b8392ee59f0d2f706580.svg";
export { ForwardRef as ReactComponent };